import React, {useEffect, useState} from 'react';
import { useAppSelector} from "../DAL/store";
import CreatorDetails from "../components/creator-details";
import Preset from "../../common/components/preset";
import Pagination from "../components/pagination";
import Preloader from "../../../../ui/svg/common/preloader";
import {Popup} from "../../../../ui/popup/popup";

/**
 * the entry point
 */
const App: React.FC = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [showLinkCopiedPopup, setShowLinkCopiedPopup] = useState(false);

    const PublicCreatorProfileData = useAppSelector((store) => store.PublicCreatorProfileData);
    const imgCdnDomain = useAppSelector((store) => store.imgCdnDomain);
    const creatorsPath = useAppSelector((store) => store.creatorsPath);

    useEffect(() => {
        //on load: if there is no url param "page" set it
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        if(urlParams.has("page") === false && PublicCreatorProfileData.profile.pageNumber > 1){
            window.history.replaceState({}, '', document.location.pathname + "?page=" + PublicCreatorProfileData.profile.pageNumber);
        }
    }, [PublicCreatorProfileData.profile.pageNumber]);

    return (
        <div className="waves-box-ml mx-auto text-left px-5 md:px-12 xl:px-0">
            <CreatorDetails cancelImgLazyload={true} profile={PublicCreatorProfileData.profile} creatorsPath={creatorsPath} imgCdnDomain={imgCdnDomain} />
            {PublicCreatorProfileData.presets.length > 0 && <div className="w-full border-b border-b-gray-600 my-4"></div>}

            <div className="flex items-center justify-between">
                {PublicCreatorProfileData.presets.length > 0 && <div className="waves-h3 font-bold pb-0 mt-6 lg:mt-12">Creator Chains</div>}
            </div>
            {PublicCreatorProfileData.presets.length > 0 &&
                <div className="w-full mt-2 mb-6">Hear chains on your tracks when you <span className="font-bold">drag & drop</span> or <span className="font-bold">copy & paste</span> chain links from the web directly into StudioRack, inside your DAW of choice.
                    <a className="text-black pl-2" href="/studioverse/about">Learn more</a>
                </div>}

            {!isLoading &&
                <div className="w-full mt-4">
                    <ul className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-12">
                        {PublicCreatorProfileData.presets.map((preset,index) => {
                            const presetTags = PublicCreatorProfileData.presetTags.filter(tag => tag.presetID === preset.presetID);
                            return <li className="grid-item pb-8" key={preset.presetID + "_" + index}>
                                        <Preset preset={preset} profile={PublicCreatorProfileData.profile}
                                                isHandleLinked={true} presetTags={presetTags} imgCdnDomain={imgCdnDomain} creatorsPath={creatorsPath}
                                                setShowLinkCopiedPopup={setShowLinkCopiedPopup} />
                                    </li>
                        })}
                    </ul>
                </div>
            }
            {showLinkCopiedPopup && <Popup classes="py-10" close={() => setShowLinkCopiedPopup(false)}>
                <div className="ok-box" role="alert">The link was copied to clipboard</div>
            </Popup>}
            {isLoading && <div className="w-full flex items-center justify-center"><Preloader width="25px" height="25px" color="#4f4f4f" /></div>}

            {PublicCreatorProfileData.profile.numberOfPages > 1 && <Pagination setIsLoading={setIsLoading} />}
            {PublicCreatorProfileData.profile.numberOfPages === 0 &&
                <div className="w-full lg:flex lg:items-center lg:justify-center mt-4">
                    <div className="info-box w-full lg:w-1/2">
                        <a href={"/studioverse/creator/" + PublicCreatorProfileData.profile.handle.toLowerCase()}>
                            @{PublicCreatorProfileData.profile.handle}
                        </a> has no presets.
                    </div>
                </div>
            }

        </div>

    );
};

export default App;

